import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['storefrontSelect']

  selectionChanged() {
    const storefront_id = this.storefrontSelectTarget.value;
    const url = `/sandbar/admin/storefronts/${storefront_id}`;
    window.location = url
  }
}
